import styled from "styled-components"

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    margin: 2rem 5rem;
    min-height: calc(100% - 6rem);
    border-radius: 2rem;
    padding: 2rem;
    box-shadow: 0 0 0.5rem var(--grey);
    background-color: var(--white);
    h1 {
        margin-top: 0;
        //margin-left: 2rem;
        padding 1rem;
        font-size: 4rem;
        margin-bottom: 0;
        font-weight: 200;
        color: black;
        background-color: rgba(255,255,255, .5);
        //opacity: .8;
        border-radius: 1.5rem;
    }
    >p {
        margin-right: 1rem;
        text-align: left;
        padding-left: 1.5rem;
    }
    ol, ul {
        margin-right: 1rem;
        text-align: left;
        padding-left: 1.5rem;
    }

    blockquote {
        margin-right: 1rem;
        text-align: left;
        padding-left: 2rem;
        ::before {
            content:'«';
        }
        ::after {
            content:'»';
        }
    }
    div.descricao {
        padding: 1rem;
        color: black;
        background-color: rgba(255,255,255, .5);
        border-radius: 1.5rem;
//      margin-left: 4rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
    .circle {
        border-radius: 50%;
        width: 26px;
        height: 26px;
        list-style-type: 28px;
        display: flex;
        position:absolute;
        float: right;
        right: 2.5rem;
        top: 2.5rem;
        align-items: center;
        text-align: center;
        z-index:1;
        background-color: rgba(#ffffff, .5);
        .icon {
          text-align: right;
          position: relative;
          top: -.5px;
          right: 0px;
        }
      }
`

export const Novo = styled.span`
    font-weight: bold;
    color: var(--green);
    position: absolute;
    left: calc(100% - 4rem);
    transform: translate(-100%);
    padding: 0.2rem;
    background-color: white;
    border-radius: 0.3rem;
`

export const ResumoContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    //height: calc(100vh - 12rem);
    background-color: var(--lightgrey);
    border-radius: 1.5rem;
    padding: 2rem;
    >div {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }
    a {
        display: inline-block;
        width: 100%;
        text-align: right;
        cursor: pointer;
    }
`

export const DataHora = styled.p`
    position: absolute;
    width: 100%;
    text-align: right;
    padding-right: 4rem;
`

export const Resumo = styled.div`
    display: flex;
    flex-grow: 1;
    gap: 1.5rem;
    overflow: hidden;
    >div{
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        width: 50%;
        >p {
          display: block;
          overflow: hidden;
          max-height: 6vh;
      }
    }
    min-height: 20vh;
`

export const Descricao = styled.div`
    >p {
        display: flex;
        flex-grow: 1;
        overflow: hidden;
        max-height: 6vh;
        > p {
            column-width: 100vw;
            //height: 100%;
            > p {
                column-width: 100vw;
                //height: 100%;
            }
        }
    }
`

export const Reportes = styled.div`
    display: flex;
    flex-grow: 1 1 0px;
    gap: 1rem;
    min-height: 20vh;
`

export const Reporte = styled.div<{ count: number }>`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 1rem;
    border-radius: 0.5rem;
    padding: 1rem;
    margin-top: 1.2rem;
    color: #464649;
    background-color: #fefefe;
    align-items: center;
    width: 100%;
    height: inherit;
    //width: ${ props => props.count >= 3 ? "calc(32vw - 7rem)" : props.count === 2 ? "45vw" : "calc(98vw - 22rem)"};
`

export const SiglaContainer = styled.div`
    position: absolute;
    transform: translateY(-65%);
`

export const ReporteHeader = styled.div`
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    margin-top: 1rem;
    width: 100%;
`

export const ReporteBody = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 1rem;
    width: 100%;
    h3 {
        margin-bottom: 0.25rem;
    }
    >div {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
    }
    >div>p {
        overflow: hidden;
        max-height: 6vh;
        >p {
            column-width: 100vw;
            height: 100%;
        }
    }
`
